export const queryKeys = {
  BOSS_FLATS_COUNT: 'BOSS_FLATS_COUNT',
  BOSS_HEADER_CARDS: 'BOSS_HEADER_CARDS',
  MONTHLY_ARREARS: 'MONTHLY_ARREARS',
  TJMS: 'TJMS',
  BOSS_HOME_PAYMENTS: 'BOSS_HOME_PAYMENTS',
  MOBILE_PAYMENTS_V2: 'MOBILE_PAYMENTS_V2'
};
